import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.previewPage || initialState;

export const selectPreviewPage = createSelector([selectSlice], state => state);
export const selectPreviewPageLoad = createSelector(
  [selectSlice],
  state => state.load,
);
